// extracted by mini-css-extract-plugin
export default {"no-result":"ProviderSelector_no-result_BVvM4"};